/* Tickling Toe · product page: gallery, variants, add to bag, sticky bar, delivery date, size chart */
(() => {
  'use strict';
  const d = document, w = window, html = d.documentElement;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const still = html.classList.contains('is-still');

  function init() {
    const pdp = $('[data-pdp]'); if (!pdp) return;
    const TT = w.TT || {};
    const g = w.gsap && !still ? w.gsap : null;
    const variants = JSON.parse($('[data-variants]', pdp)?.textContent || '[]');
    const form = $('[data-product-form]', pdp);
    const idInput = $('[data-variant-input]', pdp);
    const addBtn = $('[data-add]', pdp), addLabel = $('[data-add-label]', pdp), addPrice = $('[data-add-price]', pdp);
    const err = $('[data-add-error]', pdp);
    const sbar = $('[data-sbar]', pdp), sbarAdd = $('[data-sbar-add]', pdp), sbarPrice = $('[data-sbar-price]', pdp);

    /* ---------- gallery ---------- */
    const track = $('[data-gallery-track]', pdp);
    const slides = $$('[data-slide]', pdp), dots = $$('[data-gallery-dots] i', pdp), thumbs = $$('[data-thumb]', pdp);
    const setActive = i => { dots.forEach((x, k) => x.classList.toggle('is-on', k === i)); thumbs.forEach((x, k) => x.classList.toggle('is-on', k === i)); };
    if (track && slides.length > 1) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(slides.indexOf(e.target)); }), { root: track, threshold: [0.6] });
      slides.forEach(s => io.observe(s));
    }
    const goTo = (i, smooth = true) => { const s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: smooth && !still ? 'smooth' : 'auto' }); };
    thumbs.forEach(t => t.addEventListener('click', () => goTo(+t.dataset.thumb)));

    // the sticker cut-out pops up and can be tickled
    const cut = $('[data-cut]', pdp);
    if (cut && g) {
      g.from(cut, { yPercent: 40, scale: 0.6, rotation: -8, duration: 1.3, ease: 'elastic.out(0.7,0.45)', delay: 0.2 });
      g.from($('.pdp__sun', pdp), { scale: 0, duration: 1, ease: 'elastic.out(0.8,0.5)' });
      const wig = () => g.fromTo(cut, { rotation: 0 }, { rotation: 4, yoyo: true, repeat: 5, duration: 0.08, ease: 'sine.inOut', overwrite: 'auto', onComplete: () => g.to(cut, { rotation: 0, duration: 0.3 }) });
      cut.addEventListener('mouseenter', wig);
      cut.addEventListener('click', wig);
      if (html.classList.contains('has-hover')) {
        const slide = cut.closest('[data-slide]');
        slide.addEventListener('pointermove', e => {
          const r = slide.getBoundingClientRect();
          g.to(cut, { scale: 1.35, transformOrigin: `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`, duration: 0.4, ease: 'power3', overwrite: 'auto' });
        });
        slide.addEventListener('pointerleave', () => g.to(cut, { scale: 1, duration: 0.5, ease: 'elastic.out(0.8,0.5)', overwrite: 'auto' }));
      }
    }

    // lightbox
    const lb = $('[data-lightbox]'), lbImg = $('[data-lightbox-img]');
    $$('[data-zoom]', pdp).forEach(b => b.addEventListener('click', () => {
      lbImg.src = b.dataset.zoom; lb.hidden = false;
      g && g.fromTo(lbImg, { scale: 0.7, rotation: -4, opacity: 0 }, { scale: 1, rotation: 0, opacity: 1, duration: 0.6, ease: 'elastic.out(0.8,0.6)' });
    }));
    const closeLb = () => { lb.hidden = true; lbImg.removeAttribute('src'); };
    $('[data-lightbox-close]')?.addEventListener('click', closeLb);
    lb?.addEventListener('click', e => { if (e.target === lb) closeLb(); });
    d.addEventListener('keydown', e => { if (e.key === 'Escape' && lb && !lb.hidden) closeLb(); });

    /* ---------- twirl meter ---------- */
    const tw = $('[data-twirl]', pdp);
    if (tw && g) g.from($$('.twirl__f:not(.is-off)', tw), { scale: 0, rotation: -180, duration: 0.8, ease: 'back.out(3)', stagger: 0.12, delay: 0.6 });

    /* ---------- variants ---------- */
    const fieldsets = $$('[data-option]', pdp);
    const selected = () => fieldsets.map(f => ($('input:checked', f) || {}).value);
    const find = opts => variants.find(v => v.options.every((o, i) => o === opts[i]));
    function markAvailability() {
      const cur = selected();
      fieldsets.forEach((f, idx) => {
        $$('input', f).forEach(inp => {
          const test = cur.slice(); test[idx] = inp.value;
          const v = find(test);
          inp.closest('.chip').classList.toggle('is-unavail', !v || !v.available);
        });
      });
    }
    function waLinks(v) {
      if (!TT.wa || !TT.wa.number) return;
      const msg = (TT.wa.product || '').replace('{product}', pdp.dataset.title).replace('{size}', v ? v.title : '').replace('{url}', pdp.dataset.url + (v ? `?variant=${v.id}` : ''));
      $$('[data-wa-product]').forEach(a => { a.href = `https://wa.me/${TT.wa.number}?text=${encodeURIComponent(msg)}`; });
    }
    function update() {
      const v = find(selected());
      fieldsets.forEach(f => { const lab = $('[data-option-value]', f); const c = $('input:checked', f); if (lab && c) lab.textContent = c.value; });
      markAvailability();
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; sbarAdd && (sbarAdd.disabled = true); return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; sbarAdd && (sbarAdd.disabled = !v.available);
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      addPrice.textContent = '· ' + v.price;
      const pr = $('[data-pdp-price]', pdp);
      if (pr) pr.innerHTML = `<span class="price${v.compare ? ' price--sale' : ''}"><b data-price>${v.price}</b>${v.compare ? `<s>${v.compare}</s>` : ''}</span>`;
      if (sbarPrice) sbarPrice.textContent = v.price;
      g && g.fromTo(pr, { scale: 1.2, rotation: -4 }, { scale: 1, rotation: 0, duration: 0.5, ease: 'elastic.out(1,0.4)' });
      if (v.media) { const i = slides.findIndex(s => s.dataset.mediaId == v.media); if (i > -1) goTo(i); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      waLinks(v);
    }
    fieldsets.forEach(f => f.addEventListener('change', e => {
      update();
      const chip = e.target.closest('.chip');
      g && TT.pop && TT.pop(chip, { scale: 0.8, rotation: -8, duration: 0.6, ease: 'elastic.out(1,0.4)' });
      if (/size/i.test($('.opt__l', f)?.textContent || '')) { try { localStorage.setItem('tt-age', JSON.stringify(e.target.value)); } catch (x) {} }
    }));
    // pre-select the remembered age if it exists and nothing was chosen through the URL
    (() => {
      if (new URL(location.href).searchParams.get('variant')) return;
      let age = null; try { age = JSON.parse(localStorage.getItem('tt-age')); } catch (x) {}
      if (!age) return;
      fieldsets.forEach(f => {
        if (!/size/i.test($('.opt__l', f)?.textContent || '')) return;
        const inp = $$('input', f).find(i => i.value === age);
        if (inp) { inp.checked = true; }
      });
    })();
    if (fieldsets.length) update(); else waLinks(variants[0]);

    /* qty */
    $$('[data-qty]', form).forEach(q => {
      const input = $('[data-qty-input]', q);
      $('[data-qty-plus]', q).addEventListener('click', () => { input.value = +input.value + 1; });
      $('[data-qty-minus]', q).addEventListener('click', () => { input.value = Math.max(1, +input.value - 1); });
    });

    /* add to bag */
    form?.addEventListener('submit', async e => {
      e.preventDefault();
      if (!TT.cart) return form.submit();
      err.hidden = true; addBtn.classList.add('is-pressed'); addBtn.setAttribute('aria-busy', 'true');
      const fd = new FormData(form);
      const props = {};
      for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; }
      const img = $('[data-cut]', pdp) || $('.pdp__slide img', pdp);
      try {
        await TT.cart.add([{ id: +idInput.value, quantity: +(fd.get('quantity') || 1), properties: props }], img);
      } catch (x) {
        err.textContent = x.message; err.hidden = false;
      } finally { addBtn.classList.remove('is-pressed'); addBtn.removeAttribute('aria-busy'); }
    });
    sbarAdd?.addEventListener('click', () => { if (!$('input:checked', fieldsets[0] || d) && fieldsets.length) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } form.requestSubmit ? form.requestSubmit() : form.submit(); });

    /* sticky bar appears once the main button scrolls away */
    if (sbar && 'IntersectionObserver' in w) {
      const io = new IntersectionObserver(([e]) => { const on = !e.isIntersecting && e.boundingClientRect.top < 0; sbar.classList.toggle('is-on', on); sbar.setAttribute('aria-hidden', on ? 'false' : 'true'); $$('a,button', sbar).forEach(x => x.tabIndex = on ? 0 : -1); });
      io.observe(addBtn);
    }

    /* ---------- delivery date by pincode ---------- */
    const dlv = $('[data-delivery]', pdp), pinForm = $('[data-pin-form]', pdp);
    if (pinForm) {
      const out = $('[data-pin-out]', pinForm), pin = $('[data-pin]', pinForm);
      const fmt = dt => dt.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      const addWorking = (date, n) => { const x = new Date(date); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) n--; } return x; };
      const saved = (() => { try { return localStorage.getItem('tt-pin'); } catch (x) { return null; } })();
      const run = () => {
        const v = pin.value.trim();
        if (!/^[1-9][0-9]{5}$/.test(v)) { out.innerHTML = 'Please enter a 6-digit pincode'; return; }
        try { localStorage.setItem('tt-pin', v); } catch (x) {}
        const local = /^(36|37|38|39)/.test(v);
        const dispatch = +dlv.dataset.dispatch, transit = local ? +dlv.dataset.local : +dlv.dataset.india;
        const from = addWorking(new Date(), dispatch + transit), to = addWorking(from, local ? 1 : 2);
        out.innerHTML = `Arrives <b>${fmt(from)} – ${fmt(to)}</b>${local ? ' · zooming over from Surat!' : ''}`;
        g && g.fromTo(out, { y: 8, opacity: 0 }, { y: 0, opacity: 1, duration: 0.4, ease: 'back.out(2)' });
      };
      pinForm.addEventListener('submit', e => { e.preventDefault(); run(); });
      if (saved) { pin.value = saved; run(); }
    }

    /* ---------- size chart sheet ---------- */
    const guide = $('[data-guide]');
    if (guide) {
      const card = $('.sheet__card', guide);
      $$('[data-guide-open]').forEach(b => b.addEventListener('click', () => {
        guide.hidden = false; TT.lenis && TT.lenis.stop();
        const age = ($$('[data-option]', pdp).map(f => /size/i.test($('.opt__l', f)?.textContent || '') ? ($('input:checked', f) || {}).value : null).find(Boolean)) || '';
        $$('tr[data-age]', guide).forEach(r => r.classList.toggle('is-sel', r.dataset.age === age));
        g && g.fromTo(card, { yPercent: 100 }, { yPercent: 0, duration: 0.6, ease: 'elastic.out(0.8,0.75)' });
      }));
      const close = () => { guide.hidden = true; TT.lenis && TT.lenis.start(); };
      $$('[data-guide-close]', guide).forEach(b => b.addEventListener('click', close));
      guide.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
